import axios from '@/libs/axios';
import { MutationConfig, queryClient } from '@/libs/react-query';
import { ListQueryKey, Urls } from '../constant';
import { useMutation } from '@tanstack/react-query';

//
export interface UpdateRequest {
  id: number;
  user_name: string;
  open_bank: string;
  bank_name: string;
  card_num: string;
}

export interface UpdateResponse extends Response {
  data: null;
}

//
export const update = (data: UpdateRequest): Promise<UpdateResponse> => {
  return axios.post(Urls.updateUrl, data);
};

type UseUpdateOptions = {
  config?: MutationConfig<typeof update>;
};

//
export const useUpdate = ({ config }: UseUpdateOptions) => {
  return useMutation({
    onSettled: () => {
      queryClient.invalidateQueries([ListQueryKey]);
    },
    mutationFn: update,
    ...config,
  });
};
